import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import InferenceHomepage from '../components/inference/inference-homepage';

export default function HomePage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // Override click handlers on the page to wire navigation
  const handleClick = (e) => {
    const target = e.target.closest('button, a');
    if (!target) return;

    const text = target.textContent?.trim();
    if (text === 'Sign In') {
      e.preventDefault();
      navigate(isAuthenticated ? '/app' : '/login');
    } else if (text === 'Start Free' || text === 'Start Free →') {
      e.preventDefault();
      navigate(isAuthenticated ? '/app' : '/signup');
    } else if (text === 'Pricing') {
      e.preventDefault();
      // scroll to pricing or navigate
    }
  };

  return (
    <div onClick={handleClick}>
      <InferenceHomepage />
    </div>
  );
}
